$(document).ready(function() {
	/*
	 * Dropdown functionality ('Show more', 'Show all events')
	 * IMPORTANT: Mirror element for each button needed (same element, different text to display after click)
	 *
	 * @return [void]
	 */
	function eventItemsToggle() {
		// Get element's "id"
		var id = $(this).attr('id');
		
		if (!id) {
			throw new Error('No "id" attribute defined at element "' + $(this).attr('class') + '"');	
		}

		// Get event name (to toggle)
		var event = id.trim().substring(0, id.indexOf('--'));

		if (!event) {
			throw new Error('Wrong "id" attribute sufix at element "' + id + '" - attribute name should contain unique sufix preceded by "--"');
		}

		// Find mirror element/s
		var mirror = $(this).siblings();

		if (!mirror.length) {
			throw new Error('No mirror element for ' + id);
		}
		
		// Find all elements with same "class" as button "id" value and toggle them
		$('.' + event).toggle();

		// Hide this button, reveal it's mirror
		$(this).addClass('hide');
		mirror.removeClass('hide');
	}
    
    $('.hidden-events').hide();
    $('.hidden-news').hide();

	// Event delegation
	$('#events').on('click', '.see-more', eventItemsToggle);
    $('#news').on('click', '.see-more', eventItemsToggle);
})